import { lazy, useMemo } from 'react';
import { DataImportAccessGuard } from './DataImportAccessGuard';
import { createProtectedElement } from './create-protected-element';

const CurveListPage = lazy(() => import('../../features/curves/curve-list/Page'));
const ValuationRuns = lazy(() => import('../../features/valuation-runs'));
const ValuationRangeRuns = lazy(() => import('../../features/valuation-runs/ValuationRangeRuns'));
const ValuationRunDetailsPage = lazy(() => import('../../features/valuation-runs/run-details/ValuationPage'));
const Indexes = lazy(() => import('../../features/indexes/Page'));
const PortfolioSetupPage2 = lazy(() => import('../../features/portfolio-setup-2'));
const PortfolioSetupPage2Detail = lazy(() => import('../../features/portfolio-setup-2-detail'));
const PricingPage = lazy(() => import('../../features/pricing/Page'));
const MarketDataReportPage = lazy(() => import('../../features/market-data-report/Page'));
const CurveDetailsPage = lazy(() => import('../../features/curves/curve-details/DetailsPage'));
const AssetMasterPage = lazy(() => import('../../features/asset-master/AssetMaster'));
const AssetDetailsPage = lazy(() => import('../../features/asset-master/asset-details/AssetDetails'));
const ClassificationRunDetailsPage = lazy(() => import('../../features/valuation-runs/run-details/ClassificationPage'));
const PortfoliosPage = lazy(() => import('../../features/portfolios/Page'));
const SplitFlagsPage = lazy(() => import('../../features/split-flags/Page'));
const SplitDetailPage = lazy(() => import('../../features/split-flags/detail/Page'));
const Entities = lazy(() => import('../../features/entities/Page'));
const EntityMaster = lazy(() => import('../../features/entity-master/EntityMaster'));
const RiskRunDetailsPage = lazy(() => import('../../features/valuation-runs/run-details/risk-details/RiskDetailsPage'));
const RiskRunParentPage = lazy(() => import('../../features/valuation-runs/run-details/risk-runs/RiskRunParentPage'));
const DataImportRouter = lazy(() =>
  import('../../features/data-import').then((m) => ({ default: m.DataImportRouter })),
);

export const useProtectedPages = (isSidebarVisible: boolean) => {
  const ProtectedCurveListPage = useMemo(() => createProtectedElement(CurveListPage), []);
  const ProtectedMarketDataReportPage = useMemo(() => createProtectedElement(MarketDataReportPage), []);
  const ProtectedPricingPage = useMemo(() => createProtectedElement(PricingPage), []);
  const ProtectedAssetDetailsPage = useMemo(() => createProtectedElement(AssetDetailsPage), []);
  const ProtectedAssetMasterPage = useMemo(() => createProtectedElement(AssetMasterPage), []);
  const ProtectedPortfolioSetupPage2Detail = useMemo(() => createProtectedElement(PortfolioSetupPage2Detail), []);
  const ProtectedPortfolioSetupPage2 = useMemo(() => createProtectedElement(PortfolioSetupPage2), []);
  const ProtectedPortfoliosPage = useMemo(() => createProtectedElement(PortfoliosPage), []);
  const ProtectedIndexes = useMemo(() => createProtectedElement(Indexes), []);
  const ProtectedValuationRunDetailsPage = useMemo(() => createProtectedElement(ValuationRunDetailsPage), []);
  const ProtectedValuationRuns = useMemo(() => createProtectedElement(ValuationRuns), []);
  const ProtectedValuationRangeRuns = useMemo(() => createProtectedElement(ValuationRangeRuns), []);
  const ProtectedClassificationRunDetailsPage = useMemo(() => createProtectedElement(ClassificationRunDetailsPage), []);
  const ProtectedRiskRunParentPage = useMemo(() => createProtectedElement(RiskRunParentPage), []);
  const ProtectedRiskRunDetailsPage = useMemo(() => createProtectedElement(RiskRunDetailsPage), []);
  const ProtectedSplitDetailPage = useMemo(() => createProtectedElement(SplitDetailPage), []);
  const ProtectedSplitFlagsPage = useMemo(() => createProtectedElement(SplitFlagsPage), []);
  const ProtectedEntities = useMemo(() => createProtectedElement(Entities), []);
  const ProtectedEntityMaster = useMemo(() => createProtectedElement(EntityMaster), []);
  const ProtectedDataImport = useMemo(
    () =>
      createProtectedElement(() => (
        <DataImportAccessGuard>
          <DataImportRouter />
        </DataImportAccessGuard>
      )),
    [],
  );
  const ProtectedCurveDetailsPage = useMemo(
    () => createProtectedElement(() => <CurveDetailsPage isSidebarVisible={isSidebarVisible} />),
    [isSidebarVisible],
  );

  return {
    ProtectedCurveListPage,
    ProtectedCurveDetailsPage,
    ProtectedMarketDataReportPage,
    ProtectedPricingPage,
    ProtectedAssetDetailsPage,
    ProtectedAssetMasterPage,
    ProtectedPortfolioSetupPage2Detail,
    ProtectedPortfolioSetupPage2,
    ProtectedPortfoliosPage,
    ProtectedIndexes,
    ProtectedValuationRunDetailsPage,
    ProtectedValuationRuns,
    ProtectedValuationRangeRuns,
    ProtectedClassificationRunDetailsPage,
    ProtectedRiskRunParentPage,
    ProtectedRiskRunDetailsPage,
    ProtectedSplitDetailPage,
    ProtectedSplitFlagsPage,
    ProtectedEntities,
    ProtectedEntityMaster,
    ProtectedDataImport,
  };
};
